<template>
  <aside class="automacao-editor__sidebar">
    <p class="automacao-editor__coluna-titulo">{{ titulo }}</p>

    <div v-if="!no" class="automacao-editor__sidebar-vazio">
      <span class="automacao-editor__sidebar-vazio-icone" aria-hidden="true">
        <i class="fas fa-mouse-pointer"></i>
      </span>
      <p>Selecione um bloco no fluxo para configurar.</p>
    </div>

    <div v-else class="automacao-editor__sidebar-form">
      <p class="automacao-editor__coluna-ajuda">{{ descricao }}</p>

      <div v-if="avisos.length" class="automacao-editor__pendencia" role="alert">
        <ul>
          <li v-for="(aviso, indice) in avisos" :key="indice">{{ aviso }}</li>
        </ul>
      </div>

      <div v-if="usaOportunidadeDoFluxo" class="form-group">
        <label class="automacao-editor__rotulo">Oportunidade</label>
        <select class="custom-select" :value="no.data.alvo || 'atual'" @input="alterar('alvo', $event.target.value)">
          <option v-if="no.data.alvo === 'criada'" value="criada">Última criada neste fluxo</option>
          <option v-for="item in oportunidadesDoFluxo" :key="item.id" :value="item.id">
            {{ item.rotulo }}
          </option>
        </select>
      </div>

      <div v-if="no.data.tipo === 'oportunidade_ganha'" class="form-group">
        <label class="automacao-editor__rotulo">Quando</label>
        <input class="form-control" type="text" value="Oportunidade ganha" disabled>
      </div>

      <template v-if="no.data.tipo === 'mudanca_fase'">
        <div class="form-group">
          <label class="automacao-editor__rotulo">Pipeline</label>
          <select class="custom-select" :value="no.data.pipeline_id || ''" @input="alterarPipelineGatilho($event.target.value)">
            <option value="">Qualquer pipeline</option>
            <option v-for="pipeline in pipelines" :key="pipeline.id" :value="pipeline.id">
              {{ pipeline.value }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="automacao-editor__rotulo">Mudança</label>
          <select class="custom-select" :value="no.data.fase_regra || 'qualquer'" @input="alterarFaseRegra($event.target.value)">
            <option value="qualquer">Qualquer mudança de fase</option>
            <option value="sair">Saiu de uma fase</option>
            <option value="entrar">Entrou em uma fase</option>
            <option value="de_para">Saiu de uma fase e entrou em outra</option>
          </select>
        </div>
        <div v-if="mostraFaseDe">
          <div v-for="(faseId, indice) in faseDeIds" :key="'de-' + indice" class="automacao-editor__regra-item">
            <p v-if="indice > 0" class="automacao-editor__regra-conector">OU</p>
            <div class="automacao-editor__regra-card">
              <div class="automacao-editor__regra-card-topo">
                <span>{{ indice === 0 ? 'Saiu de' : 'Ou saiu de' }}</span>
                <button
                  v-if="faseDeIds.length > 1"
                  type="button"
                  class="automacao-editor__regra-remover"
                  title="Remover fase"
                  @click="removerIdGatilho('fase_de_ids', 'fase_de', indice)"
                >
                  <i class="fas fa-times" aria-hidden="true"></i>
                </button>
              </div>
              <div class="form-group">
                <select
                  class="custom-select"
                  :value="faseId || ''"
                  :disabled="!no.data.pipeline_id"
                  @input="alterarIdGatilho('fase_de_ids', 'fase_de', indice, $event.target.value ? Number($event.target.value) : null)"
                >
                  <option value="">Selecione a fase</option>
                  <option v-for="fase in fasesDaPipeline" :key="fase.id" :value="fase.id">
                    {{ fase.value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <button
            v-if="podeAdicionarFaseDe"
            type="button"
            class="automacao-editor__regra-add"
            @click="adicionarIdGatilho('fase_de_ids', 'fase_de', null)"
          >
            <i class="fas fa-plus" aria-hidden="true"></i>
            Adicionar fase de origem
          </button>
        </div>
        <div v-if="mostraFasePara">
          <div v-for="(faseId, indice) in faseParaIds" :key="'para-' + indice" class="automacao-editor__regra-item">
            <p v-if="indice > 0" class="automacao-editor__regra-conector">OU</p>
            <div class="automacao-editor__regra-card">
              <div class="automacao-editor__regra-card-topo">
                <span>{{ indice === 0 ? 'Entrou em' : 'Ou entrou em' }}</span>
                <button
                  v-if="faseParaIds.length > 1"
                  type="button"
                  class="automacao-editor__regra-remover"
                  title="Remover fase"
                  @click="removerIdGatilho('fase_para_ids', 'fase_para', indice)"
                >
                  <i class="fas fa-times" aria-hidden="true"></i>
                </button>
              </div>
              <div class="form-group">
                <select
                  class="custom-select"
                  :value="faseId || ''"
                  :disabled="!no.data.pipeline_id"
                  @input="alterarIdGatilho('fase_para_ids', 'fase_para', indice, $event.target.value ? Number($event.target.value) : null)"
                >
                  <option value="">Selecione a fase</option>
                  <option v-for="fase in fasesDaPipeline" :key="'para-' + fase.id" :value="fase.id">
                    {{ fase.value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <button
            v-if="podeAdicionarFasePara"
            type="button"
            class="automacao-editor__regra-add"
            @click="adicionarIdGatilho('fase_para_ids', 'fase_para', null)"
          >
            <i class="fas fa-plus" aria-hidden="true"></i>
            Adicionar fase de destino
          </button>
        </div>
      </template>

      <div v-if="no.data.tipo === 'oportunidade_criada'" class="form-group">
        <label class="automacao-editor__rotulo">Quando</label>
        <input class="form-control" type="text" value="Uma oportunidade é criada" disabled>
      </div>

      <template v-if="no.data.tipo === 'mudanca_status'">
        <div v-for="(statusId, indice) in statusIds" :key="'status-' + indice" class="automacao-editor__regra-item">
          <p v-if="indice > 0" class="automacao-editor__regra-conector">OU</p>
          <div class="automacao-editor__regra-card">
            <div class="automacao-editor__regra-card-topo">
              <span>{{ indice === 0 ? 'Status' : 'Ou status' }}</span>
              <button
                type="button"
                class="automacao-editor__regra-remover"
                title="Remover status"
                @click="removerIdGatilho('status_ids', 'status_id', indice)"
              >
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="form-group">
              <select
                class="custom-select"
                :value="statusId || ''"
                @input="alterarIdGatilho('status_ids', 'status_id', indice, $event.target.value ? Number($event.target.value) : null)"
              >
                <option value="">Selecione o status</option>
                <option v-for="item in status" :key="item.id" :value="item.id">
                  {{ item.value }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <button
          v-if="podeAdicionarStatus"
          type="button"
          class="automacao-editor__regra-add"
          @click="adicionarIdGatilho('status_ids', 'status_id', null)"
        >
          <i class="fas fa-plus" aria-hidden="true"></i>
          Adicionar status
        </button>
      </template>

      <div v-if="no.data.tipo === 'oportunidade_perdida'" class="form-group">
        <label class="automacao-editor__rotulo">Quando</label>
        <input class="form-control" type="text" value="Oportunidade perdida" disabled>
      </div>

      <div v-if="no.data.tipo === 'cadastro_cliente'" class="form-group">
        <label class="automacao-editor__rotulo">Quando</label>
        <input class="form-control" type="text" value="Um cliente é cadastrado" disabled>
      </div>

      <div v-if="no.data.tipo === 'resposta_mensagem'" class="form-group">
        <label class="automacao-editor__rotulo">Quando</label>
        <input class="form-control" type="text" value="O cliente responde uma mensagem" disabled>
      </div>

      <template v-if="no.data.tipo === 'preenchimento_campo'">
        <div v-if="campoIds.length > 1" class="form-group">
          <label class="automacao-editor__rotulo">Combinar campos</label>
          <select class="custom-select" :value="logicaCondicao" @input="alterarLogicaGatilho($event.target.value)">
            <option value="e">Todos preenchidos (E)</option>
            <option value="ou">Qualquer um (OU)</option>
          </select>
        </div>
        <div v-for="(campoId, indice) in campoIds" :key="'campo-gatilho-' + indice" class="automacao-editor__regra-item">
          <p v-if="indice > 0" class="automacao-editor__regra-conector">{{ rotuloLogica }}</p>
          <div class="automacao-editor__regra-card">
            <div class="automacao-editor__regra-card-topo">
              <span>{{ indice === 0 ? 'Campo' : rotuloLogica + ' campo' }}</span>
              <button
                type="button"
                class="automacao-editor__regra-remover"
                title="Remover campo"
                @click="removerIdGatilho('campo_ids', 'campo_id', indice)"
              >
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="form-group">
              <select
                class="custom-select"
                :value="campoId || ''"
                @input="alterarIdGatilho('campo_ids', 'campo_id', indice, $event.target.value || null)"
              >
                <option value="">Selecione o campo</option>
                <option v-for="campo in camposCustomizados" :key="campo.id" :value="campo.id">
                  {{ campo.value }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <button
          v-if="podeAdicionarCampoGatilho"
          type="button"
          class="automacao-editor__regra-add"
          @click="adicionarIdGatilho('campo_ids', 'campo_id', null)"
        >
          <i class="fas fa-plus" aria-hidden="true"></i>
          Adicionar campo
        </button>
      </template>

      <template v-if="no.data.tipo === 'pipeline_id'">
        <div v-for="(regra, indice) in regrasCondicao" :key="'pipeline-' + indice" class="automacao-editor__regra-item">
          <p v-if="indice > 0" class="automacao-editor__regra-conector">{{ rotuloLogica }}</p>
          <div class="automacao-editor__regra-card">
            <div class="automacao-editor__regra-card-topo">
              <span>Regra {{ indice + 1 }}</span>
              <button
                v-if="regrasCondicao.length > 1"
                type="button"
                class="automacao-editor__regra-remover"
                title="Remover regra"
                @click="removerRegra(indice)"
              >
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="form-group">
              <label class="automacao-editor__rotulo">Pipeline</label>
              <select class="custom-select" :value="regra.valor || ''" @input="alterarRegra(indice, 'valor', $event.target.value ? Number($event.target.value) : null)">
                <option value="">Selecione</option>
                <option v-for="pipeline in pipelines" :key="pipeline.id" :value="pipeline.id">
                  {{ pipeline.value }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <button
          v-if="podeAdicionarRegra"
          type="button"
          class="automacao-editor__regra-add"
          @click="adicionarRegra"
        >
          <i class="fas fa-plus" aria-hidden="true"></i>
          Adicionar pipeline
        </button>
      </template>

      <template v-if="no.data.tipo === 'valor'">
        <div v-if="regrasCondicao.length > 1" class="form-group">
          <label class="automacao-editor__rotulo">Combinar regras</label>
          <select class="custom-select" :value="logicaCondicao" @input="alterarLogica($event.target.value)">
            <option value="e">Todas (E)</option>
            <option value="ou">Qualquer (OU)</option>
          </select>
        </div>
        <div v-for="(regra, indice) in regrasCondicao" :key="'valor-' + indice" class="automacao-editor__regra-item">
          <p v-if="indice > 0" class="automacao-editor__regra-conector">{{ rotuloLogica }}</p>
          <div class="automacao-editor__regra-card">
            <div class="automacao-editor__regra-card-topo">
              <span>Regra {{ indice + 1 }}</span>
              <button
                v-if="regrasCondicao.length > 1"
                type="button"
                class="automacao-editor__regra-remover"
                title="Remover regra"
                @click="removerRegra(indice)"
              >
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="form-group">
              <label class="automacao-editor__rotulo">Operador</label>
              <select class="custom-select" :value="regra.op || '>='" @input="alterarRegra(indice, 'op', $event.target.value)">
                <option value=">=">Maior ou igual</option>
                <option value="<=">Menor ou igual</option>
                <option value=">">Maior que</option>
                <option value="<">Menor que</option>
                <option value="=">Igual</option>
              </select>
            </div>
            <div class="form-group">
              <label class="automacao-editor__rotulo">Valor</label>
              <input
                class="form-control"
                type="text"
                inputmode="numeric"
                placeholder="0,00"
                :value="valorFormatadoDaRegra(regra)"
                @input="alterarValorRegra(indice, $event.target.value)"
              >
            </div>
          </div>
        </div>
        <button
          v-if="podeAdicionarRegra"
          type="button"
          class="automacao-editor__regra-add"
          @click="adicionarRegra"
        >
          <i class="fas fa-plus" aria-hidden="true"></i>
          Adicionar valor
        </button>
      </template>

      <template v-if="no.data.tipo === 'origem'">
        <div v-for="(regra, indice) in regrasCondicao" :key="'origem-' + indice" class="automacao-editor__regra-item">
          <p v-if="indice > 0" class="automacao-editor__regra-conector">{{ rotuloLogica }}</p>
          <div class="automacao-editor__regra-card">
            <div class="automacao-editor__regra-card-topo">
              <span>Regra {{ indice + 1 }}</span>
              <button
                v-if="regrasCondicao.length > 1"
                type="button"
                class="automacao-editor__regra-remover"
                title="Remover regra"
                @click="removerRegra(indice)"
              >
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="form-group">
              <label class="automacao-editor__rotulo">Origem</label>
              <select class="custom-select" :value="regra.valor || 'whatsapp'" @input="alterarRegra(indice, 'valor', $event.target.value)">
                <option value="whatsapp">WhatsApp</option>
                <option value="email">E-mail</option>
                <option value="api">API</option>
                <option value="presencial">Presencial</option>
              </select>
            </div>
          </div>
        </div>
        <button
          v-if="podeAdicionarRegra"
          type="button"
          class="automacao-editor__regra-add"
          @click="adicionarRegra"
        >
          <i class="fas fa-plus" aria-hidden="true"></i>
          Adicionar origem
        </button>
      </template>

      <template v-if="no.data.tipo === 'horario'">
        <div v-for="dia in diasSemana" :key="'horario-' + dia.id" class="automacao-editor__horario-dia">
          <label class="automacao-editor__dia">
            <input
              type="checkbox"
              :checked="horarioDoDia(dia.id).ativo"
              @change="alterarHorarioDia(dia.id, 'ativo', $event.target.checked)"
            >
            {{ dia.rotulo }}
          </label>
          <input
            class="form-control"
            type="time"
            :disabled="!horarioDoDia(dia.id).ativo"
            :value="horarioDoDia(dia.id).inicio"
            @input="alterarHorarioDia(dia.id, 'inicio', $event.target.value)"
          >
          <input
            class="form-control"
            type="time"
            :disabled="!horarioDoDia(dia.id).ativo"
            :value="horarioDoDia(dia.id).fim"
            @input="alterarHorarioDia(dia.id, 'fim', $event.target.value)"
          >
        </div>
        <p class="automacao-editor__rotulo">Exceções</p>
        <div v-for="(excecao, indice) in excecoesHorario" :key="'excecao-' + indice" class="automacao-editor__regra-item">
          <div class="automacao-editor__regra-card">
            <div class="automacao-editor__regra-card-topo">
              <span>Data específica</span>
              <button
                type="button"
                class="automacao-editor__regra-remover"
                title="Remover exceção"
                @click="removerExcecao(indice)"
              >
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="form-group">
              <label class="automacao-editor__rotulo">Data</label>
              <input class="form-control" type="date" :value="excecao.data || ''" @input="alterarExcecao(indice, 'data', $event.target.value)">
            </div>
            <label class="automacao-editor__dia">
              <input
                type="checkbox"
                :checked="!!excecao.fechado"
                @change="alterarExcecao(indice, 'fechado', $event.target.checked)"
              >
              Fechado
            </label>
            <div v-if="!excecao.fechado" class="automacao-editor__horario-faixa">
              <input class="form-control" type="time" :value="excecao.inicio || ''" @input="alterarExcecao(indice, 'inicio', $event.target.value)">
              <input class="form-control" type="time" :value="excecao.fim || ''" @input="alterarExcecao(indice, 'fim', $event.target.value)">
            </div>
          </div>
        </div>
        <button
          v-if="podeAdicionarExcecao"
          type="button"
          class="automacao-editor__regra-add"
          @click="adicionarExcecao"
        >
          <i class="fas fa-plus" aria-hidden="true"></i>
          Adicionar exceção
        </button>
      </template>

      <template v-if="no.data.tipo === 'campo'">
        <div v-if="regrasCondicao.length > 1" class="form-group">
          <label class="automacao-editor__rotulo">Combinar regras</label>
          <select class="custom-select" :value="logicaCondicao" @input="alterarLogica($event.target.value)">
            <option value="e">Todas (E)</option>
            <option value="ou">Qualquer (OU)</option>
          </select>
        </div>
        <div v-for="(regra, indice) in regrasCondicao" :key="'campo-' + indice" class="automacao-editor__regra-item">
          <p v-if="indice > 0" class="automacao-editor__regra-conector">{{ rotuloLogica }}</p>
          <div class="automacao-editor__regra-card">
            <div class="automacao-editor__regra-card-topo">
              <span>Regra {{ indice + 1 }}</span>
              <button
                v-if="regrasCondicao.length > 1"
                type="button"
                class="automacao-editor__regra-remover"
                title="Remover regra"
                @click="removerRegra(indice)"
              >
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="form-group">
              <label class="automacao-editor__rotulo">Campo</label>
              <select class="custom-select" :value="regra.campo_id || ''" @input="alterarCampoRegra(indice, $event.target.value)">
                <option value="">Selecione o campo</option>
                <option v-for="campo in camposCustomizados" :key="campo.id" :value="campo.id">
                  {{ campo.value }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="automacao-editor__rotulo">Regra</label>
              <select class="custom-select" :value="regra.op || 'preenchido'" @input="alterarRegra(indice, 'op', $event.target.value)">
                <option v-for="operador in operadoresDaRegra(regra)" :key="operador.id" :value="operador.id">
                  {{ operador.value }}
                </option>
              </select>
            </div>
            <div v-if="mostraValorDaRegra(regra)" class="form-group">
              <label class="automacao-editor__rotulo">Valor</label>
              <select
                v-if="tipoDaRegra(regra) === 2"
                class="custom-select"
                :value="regra.valor || ''"
                @input="alterarRegra(indice, 'valor', $event.target.value)"
              >
                <option value="">Selecione</option>
                <option v-for="opcao in opcoesDaRegra(regra)" :key="opcao" :value="opcao">
                  {{ opcao }}
                </option>
              </select>
              <input
                v-else-if="tipoDaRegra(regra) === 3"
                class="form-control"
                type="number"
                step="any"
                :value="regra.valor || ''"
                @input="alterarRegra(indice, 'valor', $event.target.value)"
              >
              <input
                v-else-if="tipoDaRegra(regra) === 4"
                class="form-control"
                type="date"
                :value="regra.valor || ''"
                @input="alterarRegra(indice, 'valor', $event.target.value)"
              >
              <input
                v-else
                class="form-control"
                type="text"
                maxlength="500"
                :value="regra.valor || ''"
                @input="alterarRegra(indice, 'valor', $event.target.value)"
              >
            </div>
          </div>
        </div>
        <button
          v-if="podeAdicionarRegra"
          type="button"
          class="automacao-editor__regra-add"
          @click="adicionarRegra"
        >
          <i class="fas fa-plus" aria-hidden="true"></i>
          Adicionar campo
        </button>
      </template>

      <template v-if="no.data.tipo === 'resposta'">
        <div v-if="regrasCondicao.length > 1" class="form-group">
          <label class="automacao-editor__rotulo">Combinar regras</label>
          <select class="custom-select" :value="logicaCondicao" @input="alterarLogica($event.target.value)">
            <option value="e">Todas (E)</option>
            <option value="ou">Qualquer (OU)</option>
          </select>
        </div>
        <div v-for="(regra, indice) in regrasCondicao" :key="'resposta-' + indice" class="automacao-editor__regra-item">
          <p v-if="indice > 0" class="automacao-editor__regra-conector">{{ rotuloLogica }}</p>
          <div class="automacao-editor__regra-card">
            <div class="automacao-editor__regra-card-topo">
              <span>Regra {{ indice + 1 }}</span>
              <button
                v-if="regrasCondicao.length > 1"
                type="button"
                class="automacao-editor__regra-remover"
                title="Remover regra"
                @click="removerRegra(indice)"
              >
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="form-group">
              <label class="automacao-editor__rotulo">Regra</label>
              <select class="custom-select" :value="regra.op || 'respondeu'" @input="alterarRegra(indice, 'op', $event.target.value)">
                <option value="respondeu">Respondeu</option>
                <option value="=">É igual a</option>
                <option value="contem">Contém</option>
                <option value="regex">Expressão regular</option>
                <option value=">">Maior que</option>
                <option value="<">Menor que</option>
                <option value=">=">Maior ou igual</option>
                <option value="<=">Menor ou igual</option>
              </select>
            </div>
            <div v-if="mostraValorDaRegra(regra)" class="form-group">
              <label class="automacao-editor__rotulo">Valor</label>
              <input
                class="form-control"
                type="text"
                maxlength="500"
                :placeholder="regra.op === 'regex' ? 'Ex.: ^(sim|não)$' : ''"
                :value="regra.valor || ''"
                @input="alterarRegra(indice, 'valor', $event.target.value)"
              >
              <small v-if="regra.op === 'regex'" class="form-text text-muted">Ex.: ^(sim|não)$</small>
            </div>
          </div>
        </div>
        <button
          v-if="podeAdicionarRegra"
          type="button"
          class="automacao-editor__regra-add"
          @click="adicionarRegra"
        >
          <i class="fas fa-plus" aria-hidden="true"></i>
          Adicionar resposta
        </button>
      </template>

      <template v-if="no.data.tipo === 'alterar_responsavel'">
        <div class="form-group">
          <label class="automacao-editor__rotulo">Novo responsável</label>
          <select class="custom-select" :value="no.data.user_id === 0 || no.data.user_id === '0' ? '0' : (no.data.user_id || '')" @input="alterar('user_id', $event.target.value)">
            <option value="">Selecione</option>
            <option value="0">Sem responsável</option>
            <option v-for="usuario in usuariosDaLoja" :key="usuario.id" :value="usuario.id">
              {{ usuario.value }}
            </option>
          </select>
        </div>
        <dl class="automacao-editor__params">
          <dt class="automacao-editor__params-titulo">O que a ação faz</dt>
          <div class="automacao-editor__params-item">
            <dt>Oportunidade</dt>
            <dd>{{ rotuloOportunidadeAlvo }}</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Altera</dt>
            <dd>Só o responsável</dd>
          </div>
        </dl>
      </template>

      <template v-if="no.data.tipo === 'atualizar_campo'">
        <div class="form-group">
          <label class="automacao-editor__rotulo">Campo</label>
          <select class="custom-select" :value="no.data.campo_id || ''" @input="alterarCampoAtualizar($event.target.value)">
            <option value="">Selecione o campo</option>
            <option v-for="campo in camposCustomizados" :key="campo.id" :value="campo.id">
              {{ campo.value }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="automacao-editor__rotulo">Novo valor</label>
          <select
            v-if="tipoCampoSelecionado === 2"
            class="custom-select"
            :value="no.data.campo_valor || ''"
            @input="alterar('campo_valor', $event.target.value)"
          >
            <option value="">Selecione</option>
            <option v-for="opcao in opcoesCampoSelecionado" :key="opcao" :value="opcao">
              {{ opcao }}
            </option>
          </select>
          <input
            v-else-if="tipoCampoSelecionado === 3"
            class="form-control"
            type="number"
            step="any"
            :value="no.data.campo_valor || ''"
            @input="alterar('campo_valor', $event.target.value)"
          >
          <input
            v-else-if="tipoCampoSelecionado === 4"
            class="form-control"
            type="date"
            :value="no.data.campo_valor || ''"
            @input="alterar('campo_valor', $event.target.value)"
          >
          <input
            v-else
            class="form-control"
            type="text"
            maxlength="2000"
            :value="no.data.campo_valor || ''"
            @input="alterar('campo_valor', $event.target.value)"
          >
          <automacao-variavel-picker
            v-if="tipoCampoSelecionado !== 2 && tipoCampoSelecionado !== 3 && tipoCampoSelecionado !== 4"
            :fixas="variaveisFixas"
            :campos="variaveisCampos"
            @inserir="inserirVariavel('campo_valor', $event)"
          />
        </div>
        <dl class="automacao-editor__params">
          <dt class="automacao-editor__params-titulo">O que a ação faz</dt>
          <div class="automacao-editor__params-item">
            <dt>Oportunidade</dt>
            <dd>{{ rotuloOportunidadeAlvo }}</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Altera</dt>
            <dd>O campo escolhido</dd>
          </div>
        </dl>
      </template>

      <template v-if="no.data.tipo === 'criar_tarefa'">
        <div class="form-group">
          <label class="automacao-editor__rotulo">Título</label>
          <input
            class="form-control"
            type="text"
            maxlength="100"
            :value="no.data.titulo || ''"
            @input="alterar('titulo', $event.target.value)"
          >
          <automacao-variavel-picker
            :fixas="variaveisFixas"
            :campos="variaveisCampos"
            @inserir="inserirVariavel('titulo', $event)"
          />
        </div>
        <div class="form-group">
          <label class="automacao-editor__rotulo">Tipo</label>
          <select class="custom-select" :value="no.data.tipo_tarefa || 'ligar'" @input="alterar('tipo_tarefa', $event.target.value)">
            <option value="ligar">Ligar</option>
            <option value="email">E-mail</option>
            <option value="reuniao">Reunião</option>
            <option value="visita">Visita</option>
          </select>
        </div>
        <div class="form-group">
          <label class="automacao-editor__rotulo">Prazo (dias)</label>
          <input
            class="form-control"
            type="number"
            min="0"
            max="365"
            :value="no.data.prazo_dias || 0"
            @input="alterar('prazo_dias', $event.target.value)"
          >
        </div>
        <div class="form-group">
          <label class="automacao-editor__rotulo">Descrição</label>
          <textarea
            class="form-control"
            rows="3"
            maxlength="4200"
            :value="no.data.descricao || ''"
            @input="alterar('descricao', $event.target.value)"
          ></textarea>
          <automacao-variavel-picker
            :fixas="variaveisFixas"
            :campos="variaveisCampos"
            @inserir="inserirVariavel('descricao', $event)"
          />
        </div>
        <dl class="automacao-editor__params">
          <dt class="automacao-editor__params-titulo">O que a ação faz</dt>
          <div class="automacao-editor__params-item">
            <dt>Oportunidade</dt>
            <dd>{{ rotuloOportunidadeAlvo }}</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Responsável</dt>
            <dd>O da oportunidade escolhida</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Cliente e loja</dt>
            <dd>Da oportunidade escolhida</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Status</dt>
            <dd>Não concluída</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Data</dt>
            <dd>Hoje + prazo em dias, 09:00</dd>
          </div>
          <div v-if="!usaOportunidadeAtual" class="automacao-editor__params-item">
            <dt>Ordem no fluxo</dt>
            <dd>Depois do bloco escolhido</dd>
          </div>
        </dl>
      </template>

      <template v-if="no.data.tipo === 'enviar_mensagem'">
        <div class="form-group">
          <label class="automacao-editor__rotulo">Canal</label>
          <select class="custom-select" :value="no.data.canal || 'email'" @input="alterar('canal', $event.target.value)">
            <option value="email">E-mail</option>
            <option value="whatsapp">WhatsApp</option>
          </select>
        </div>
        <div v-if="no.data.canal === 'whatsapp'" class="form-group">
          <label class="automacao-editor__rotulo">Conexão</label>
          <select class="custom-select" :value="no.data.config_eloca_hyperflow_id || ''" @input="alterarConexaoWhatsapp($event.target.value)">
            <option value="">Selecione a conexão</option>
            <option v-for="conexao in conexoes" :key="conexao.id" :value="conexao.id">
              {{ conexao.value }}
            </option>
          </select>
        </div>
        <div v-if="mostraTemplateWhatsapp" class="form-group">
          <label class="automacao-editor__rotulo">Template</label>
          <select class="custom-select" :value="no.data.template_id || ''" @input="alterar('template_id', $event.target.value)">
            <option value="">Selecione o template</option>
            <option v-for="template in templatesDaConexao" :key="template.id" :value="template.id">
              {{ template.value }}
            </option>
          </select>
        </div>
        <template v-if="mostraTextoWhatsappLivre">
          <div class="form-group">
            <label class="automacao-editor__rotulo">Texto</label>
            <textarea
              class="form-control"
              rows="4"
              maxlength="4200"
              :value="no.data.corpo || ''"
              @input="alterar('corpo', $event.target.value)"
            ></textarea>
            <automacao-variavel-picker
              :fixas="variaveisFixas"
              :campos="variaveisCampos"
              @inserir="inserirVariavel('corpo', $event)"
            />
          </div>
        </template>
        <template v-if="no.data.canal !== 'whatsapp'">
          <div class="form-group">
            <label class="automacao-editor__rotulo">Enviar para</label>
            <select class="custom-select" :value="no.data.destinatario_email_tipo || 'cliente'" @input="alterar('destinatario_email_tipo', $event.target.value)">
              <option value="cliente">E-mail do cliente</option>
              <option value="outro">Outro e-mail</option>
            </select>
          </div>
          <div v-if="no.data.destinatario_email_tipo === 'outro'" class="form-group">
            <label class="automacao-editor__rotulo">E-mail</label>
            <input
              class="form-control"
              type="email"
              maxlength="150"
              autocomplete="off"
              :value="no.data.destinatario_email || ''"
              @input="alterar('destinatario_email', $event.target.value)"
            >
          </div>
          <div class="form-group">
            <label class="automacao-editor__rotulo">Assunto</label>
            <input
              class="form-control"
              type="text"
              maxlength="150"
              :value="no.data.assunto || ''"
              @input="alterar('assunto', $event.target.value)"
            >
            <automacao-variavel-picker
              :fixas="variaveisFixas"
              :campos="variaveisCampos"
              @inserir="inserirVariavel('assunto', $event)"
            />
          </div>
          <div class="form-group">
            <label class="automacao-editor__rotulo">Texto</label>
            <textarea
              class="form-control"
              rows="4"
              maxlength="4200"
              :value="no.data.corpo || ''"
              @input="alterar('corpo', $event.target.value)"
            ></textarea>
            <automacao-variavel-picker
              :fixas="variaveisFixas"
              :campos="variaveisCampos"
              @inserir="inserirVariavel('corpo', $event)"
            />
          </div>
        </template>
        <div v-if="no.data.canal === 'whatsapp'" class="form-group">
          <label class="automacao-editor__rotulo">Aguardar resposta</label>
          <select class="custom-select" :value="aguardarRespostaValor" @input="alterar('aguardar_resposta', $event.target.value)">
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </select>
        </div>
        <div v-if="no.data.canal === 'whatsapp' && aguardaResposta" class="form-group">
          <label class="automacao-editor__rotulo">Prazo (horas)</label>
          <input
            class="form-control"
            type="number"
            min="1"
            max="168"
            :value="no.data.prazo_horas || 24"
            @input="alterar('prazo_horas', $event.target.value)"
          >
        </div>
        <dl class="automacao-editor__params">
          <dt class="automacao-editor__params-titulo">O que a ação faz</dt>
          <div class="automacao-editor__params-item">
            <dt>Oportunidade</dt>
            <dd>{{ rotuloOportunidadeAlvo }}</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Destinatário</dt>
            <dd>{{ rotuloDestinatarioMensagem }}</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Canal</dt>
            <dd>{{ rotuloCanalMensagem }}</dd>
          </div>
        </dl>
      </template>

      <template v-if="no.data.tipo === 'criar_oportunidade'">
        <div class="form-group">
          <label class="automacao-editor__rotulo">Origem</label>
          <select class="custom-select" :value="no.data.origem || 'atual'" @input="alterar('origem', $event.target.value)">
            <option value="atual">Aproveitar a oportunidade atual</option>
            <option value="nova">Criar nova com parâmetros</option>
          </select>
        </div>
        <template v-if="no.data.origem === 'nova'">
          <div class="form-group">
            <label class="automacao-editor__rotulo">Nome</label>
            <input
              class="form-control"
              type="text"
              maxlength="150"
              :value="no.data.nome || ''"
              @input="alterar('nome', $event.target.value)"
            >
          </div>
        </template>

        <dl class="automacao-editor__params">
          <dt class="automacao-editor__params-titulo">O que a ação faz</dt>
          <div class="automacao-editor__params-item">
            <dt>Cliente</dt>
            <dd>Da oportunidade atual</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Loja</dt>
            <dd>Da oportunidade atual</dd>
          </div>
          <div v-if="!no.data.origem || no.data.origem === 'atual'" class="automacao-editor__params-item">
            <dt>Nome</dt>
            <dd>Da oportunidade atual</dd>
          </div>
          <div v-if="!no.data.origem || no.data.origem === 'atual' || herdaResponsavel" class="automacao-editor__params-item">
            <dt>Responsável</dt>
            <dd>Da oportunidade atual</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Status</dt>
            <dd>Aberta</dd>
          </div>
        </dl>
      </template>

      <template v-if="no.data.tipo === 'criar_oportunidade' || no.data.tipo === 'mover_fase'">
        <div class="form-group">
          <label class="automacao-editor__rotulo">{{ no.data.tipo === 'mover_fase' ? 'Mover para' : 'Criar em' }}</label>
          <select class="custom-select" :value="no.data.pipeline_id || ''" @input="alterarPipeline($event.target.value)">
            <option value="">Selecione a pipeline</option>
            <option v-for="pipeline in pipelines" :key="pipeline.id" :value="pipeline.id">
              {{ pipeline.value }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="automacao-editor__rotulo">Fase</label>
          <select class="custom-select" :value="no.data.fase_id || ''" @input="alterar('fase_id', $event.target.value)">
            <option value="">{{ no.data.tipo === 'mover_fase' ? 'Selecione a fase' : 'Primeira fase' }}</option>
            <option v-for="fase in fasesDaPipeline" :key="fase.id" :value="fase.id">
              {{ fase.value }}
            </option>
          </select>
        </div>
        <div v-if="no.data.tipo === 'criar_oportunidade'" class="form-group">
          <label class="automacao-editor__rotulo">Responsável</label>
          <select class="custom-select" :value="responsavelSelecionado" @input="alterar('user_id', $event.target.value)">
            <option value="atual">Mesmo da oportunidade atual</option>
            <option value="0">Sem responsável</option>
            <option v-for="usuario in usuariosDaPipeline" :key="usuario.id" :value="usuario.id">
              {{ usuario.value }}
            </option>
          </select>
        </div>
        <dl v-if="no.data.tipo === 'mover_fase'" class="automacao-editor__params">
          <dt class="automacao-editor__params-titulo">O que a ação faz</dt>
          <div class="automacao-editor__params-item">
            <dt>Oportunidade</dt>
            <dd>{{ rotuloOportunidadeAlvo }}</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Altera</dt>
            <dd>Só a fase</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Se já estiver nela</dt>
            <dd>Não faz nada</dd>
          </div>
        </dl>
      </template>

      <template v-if="no.data.tipo === 'notificar_gestor'">
        <dl class="automacao-editor__params">
          <dt class="automacao-editor__params-titulo">O que a ação faz</dt>
          <div class="automacao-editor__params-item">
            <dt>Oportunidade</dt>
            <dd>{{ rotuloOportunidadeAlvo }}</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Destinatários</dt>
            <dd>Admins e gerentes da loja</dd>
          </div>
          <div class="automacao-editor__params-item">
            <dt>Canal</dt>
            <dd>Notificação do painel</dd>
          </div>
        </dl>
      </template>
    </div>
  </aside>
</template>

<script>
import { LIMITE_REGRAS_CONDICAO, idsDoGatilho, regrasDaCondicao } from './automacao-drawflow'
import AutomacaoVariavelPicker from './AutomacaoVariavelPicker.vue'

function parsearValorBr(valor) {
  if (valor === null || valor === undefined || valor === '') {
    return null
  }
  if (typeof valor === 'number' && !isNaN(valor)) {
    return valor
  }
  const texto = String(valor).trim()
  if (texto.indexOf(',') !== -1) {
    const numero = parseFloat(texto.replace(/\./g, '').replace(',', '.'))
    return isNaN(numero) ? null : numero
  }
  const numero = parseFloat(texto)
  return isNaN(numero) ? null : numero
}

function formatarValorBr(valor) {
  const numero = parsearValorBr(valor)
  if (numero === null) {
    return ''
  }
  return numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function mascararValorDigitado(texto) {
  const digitos = String(texto).replace(/\D/g, '')
  if (!digitos) {
    return ''
  }
  return formatarValorBr(parseInt(digitos, 10) / 100)
}

export default {
  name: 'AutomacaoSidebar',
  components: {
    AutomacaoVariavelPicker,
  },
  props: {
    no: {
      type: Object,
      default: null,
    },
    pipelines: {
      type: Array,
      default: function () {
        return []
      },
    },
    fasesPorPipeline: {
      type: Object,
      default: function () {
        return {}
      },
    },
    templates: {
      type: Array,
      default: function () {
        return []
      },
    },
    conexoes: {
      type: Array,
      default: function () {
        return []
      },
    },
    usuariosPorPipeline: {
      type: Object,
      default: function () {
        return {}
      },
    },
    oportunidadesDoFluxo: {
      type: Array,
      default: function () {
        return [{ id: 'atual', rotulo: 'A que disparou o fluxo' }]
      },
    },
    camposCustomizados: {
      type: Array,
      default: function () {
        return []
      },
    },
    status: {
      type: Array,
      default: function () {
        return []
      },
    },
    errosPorNo: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  mounted() {
    this.sincronizarSelects()
  },
  updated() {
    this.sincronizarSelects()
  },
  computed: {
    avisos() {
      if (!this.no) {
        return []
      }
      return this.errosPorNo[String(this.no.id)] || []
    },
    titulo() {
      if (!this.no) {
        return 'Configuração'
      }
      if (this.no.data.tipo_no === 'gatilho') {
        return 'Gatilho'
      }
      if (this.no.data.tipo_no === 'condicao') {
        return 'Condição'
      }
      return 'Ação'
    },
    descricao() {
      if (!this.no) {
        return ''
      }
      if (this.no.data.tipo === 'pipeline_id') {
        return 'Sim segue se a oportunidade estiver em uma das pipelines. Não segue pelo outro ramo.'
      }
      if (this.no.data.tipo === 'valor') {
        return 'Sim segue se o valor total atender a combinação das regras. Não segue pelo outro ramo.'
      }
      if (this.no.data.tipo === 'criar_oportunidade') {
        return 'Abre um registro novo (status Aberta) na pipeline/fase. Cliente e loja vêm da oportunidade que disparou.'
      }
      if (this.no.data.tipo === 'mover_fase') {
        return 'Altera só a fase da oportunidade escolhida no fluxo. Não cria registro novo.'
      }
      if (this.no.data.tipo === 'criar_tarefa') {
        return 'Cria a tarefa no responsável da oportunidade escolhida no fluxo.'
      }
      if (this.no.data.tipo === 'enviar_mensagem') {
        return 'Usa a oportunidade escolhida no fluxo: e-mail no SMTP da loja ou WhatsApp na conexão. Oficial envia template; não oficial envia texto. Dá para aguardar a resposta.'
      }
      if (this.no.data.tipo === 'resposta') {
        return 'Sim segue se a resposta da mensagem enviada neste fluxo atender as regras. Sem resposta, segue pelo Não.'
      }
      if (this.no.data.tipo === 'notificar_gestor') {
        return 'Notifica no painel os admins e gerentes da loja sobre a oportunidade escolhida no fluxo.'
      }
      if (this.no.data.tipo === 'origem') {
        return 'Sim segue se o canal da oportunidade for uma das origens. Não segue pelo outro ramo.'
      }
      if (this.no.data.tipo === 'horario') {
        return 'Sim segue no horário de cada dia. Uma exceção troca o horário daquela data, ou marca o dia como fechado.'
      }
      if (this.no.data.tipo === 'campo') {
        return 'Sim segue se os campos da oportunidade atenderem a combinação das regras. Não segue pelo outro ramo.'
      }
      if (this.no.data.tipo === 'alterar_responsavel') {
        return 'Troca o responsável da oportunidade escolhida no fluxo.'
      }
      if (this.no.data.tipo === 'atualizar_campo') {
        return 'Grava o valor no campo customizado da oportunidade escolhida.'
      }
      if (this.no.data.tipo === 'mudanca_fase') {
        return 'Dispara quando a oportunidade muda de fase. Dá para limitar a pipeline e se saiu de uma fase, entrou em outra ou os dois.'
      }
      if (this.no.data.tipo === 'oportunidade_criada') {
        return 'Dispara quando uma oportunidade é criada.'
      }
      if (this.no.data.tipo === 'mudanca_status') {
        return 'Dispara quando o status passa a ser um dos escolhidos. Sem status, qualquer mudança dispara.'
      }
      if (this.no.data.tipo === 'oportunidade_perdida') {
        return 'Dispara quando a oportunidade é perdida.'
      }
      if (this.no.data.tipo === 'cadastro_cliente') {
        return 'Dispara quando um cliente é cadastrado. Crie a oportunidade no fluxo se a ação precisar dela.'
      }
      if (this.no.data.tipo === 'resposta_mensagem') {
        return 'Dispara quando o cliente responde no WhatsApp.'
      }
      if (this.no.data.tipo === 'preenchimento_campo') {
        return 'Dispara ao preencher um dos campos. Com E, só dispara quando todos os escolhidos estiverem preenchidos. Sem campo, qualquer preenchimento dispara.'
      }
      return 'Define o momento em que a automação inicia.'
    },
    diasSemana() {
      return [
        { id: 1, rotulo: 'Seg' },
        { id: 2, rotulo: 'Ter' },
        { id: 3, rotulo: 'Qua' },
        { id: 4, rotulo: 'Qui' },
        { id: 5, rotulo: 'Sex' },
        { id: 6, rotulo: 'Sáb' },
        { id: 0, rotulo: 'Dom' },
      ]
    },
    fasesDaPipeline() {
      if (!this.no || !this.no.data.pipeline_id) {
        return []
      }
      return this.fasesPorPipeline[this.no.data.pipeline_id] || this.fasesPorPipeline[String(this.no.data.pipeline_id)] || []
    },
    usuariosDaLoja() {
      const mapa = {}
      Object.keys(this.usuariosPorPipeline || {}).forEach((pipelineId) => {
        (this.usuariosPorPipeline[pipelineId] || []).forEach(function (usuario) {
          mapa[usuario.id] = usuario
        })
      })
      return Object.keys(mapa).map(function (id) {
        return mapa[id]
      })
    },
    usuariosDaPipeline() {
      if (!this.no || !this.no.data.pipeline_id) {
        return []
      }
      return this.usuariosPorPipeline[this.no.data.pipeline_id] || this.usuariosPorPipeline[String(this.no.data.pipeline_id)] || []
    },
    responsavelSelecionado() {
      if (!this.no) {
        return 'atual'
      }
      if (this.no.data.user_id === 0 || this.no.data.user_id === '0') {
        return '0'
      }
      if (this.no.data.user_id && this.no.data.user_id !== 'atual') {
        return this.no.data.user_id
      }
      if (this.no.data.herdar_responsavel === false || this.no.data.herdar_responsavel === '0') {
        return '0'
      }
      return 'atual'
    },
    herdaResponsavel() {
      return this.responsavelSelecionado === 'atual'
    },
    usaOportunidadeDoFluxo() {
      if (!this.no) {
        return false
      }
      return ['criar_tarefa', 'enviar_mensagem', 'mover_fase', 'notificar_gestor', 'alterar_responsavel', 'atualizar_campo'].indexOf(this.no.data.tipo) !== -1
    },
    usaOportunidadeAtual() {
      if (!this.no) {
        return true
      }
      return !this.no.data.alvo || this.no.data.alvo === 'atual'
    },
    regrasCondicao() {
      return regrasDaCondicao(this.no && this.no.data)
    },
    logicaCondicao() {
      if (!this.no) {
        return 'ou'
      }
      if (this.no.data.tipo === 'pipeline_id' || this.no.data.tipo === 'origem') {
        return 'ou'
      }
      return this.no.data.logica === 'e' ? 'e' : 'ou'
    },
    rotuloLogica() {
      return this.logicaCondicao === 'e' ? 'E' : 'OU'
    },
    excecoesHorario() {
      if (!this.no || !Array.isArray(this.no.data.excecoes)) {
        return []
      }
      return this.no.data.excecoes
    },
    podeAdicionarExcecao() {
      return this.excecoesHorario.length < 30
    },
    podeAdicionarRegra() {
      return this.regrasCondicao.length < LIMITE_REGRAS_CONDICAO
    },
    faseDeIds() {
      const ids = idsDoGatilho(this.no && this.no.data, 'fase_de_ids', 'fase_de')
      return ids.length ? ids : [null]
    },
    faseParaIds() {
      const ids = idsDoGatilho(this.no && this.no.data, 'fase_para_ids', 'fase_para')
      return ids.length ? ids : [null]
    },
    statusIds() {
      return idsDoGatilho(this.no && this.no.data, 'status_ids', 'status_id')
    },
    campoIds() {
      return idsDoGatilho(this.no && this.no.data, 'campo_ids', 'campo_id')
    },
    podeAdicionarFaseDe() {
      return this.faseDeIds.length < LIMITE_REGRAS_CONDICAO
    },
    podeAdicionarFasePara() {
      return this.faseParaIds.length < LIMITE_REGRAS_CONDICAO
    },
    podeAdicionarStatus() {
      return this.statusIds.length < LIMITE_REGRAS_CONDICAO
    },
    podeAdicionarCampoGatilho() {
      return this.campoIds.length < LIMITE_REGRAS_CONDICAO
    },
    variaveisFixas() {
      return [
        { chave: 'cliente_nome', rotulo: 'Cliente' },
        { chave: 'cliente_email', rotulo: 'E-mail' },
        { chave: 'cliente_telefone', rotulo: 'Telefone' },
        { chave: 'oportunidade_nome', rotulo: 'Oportunidade' },
        { chave: 'valor', rotulo: 'Valor' },
        { chave: 'fase', rotulo: 'Fase' },
        { chave: 'fase_anterior', rotulo: 'Fase anterior' },
        { chave: 'pipeline_nome', rotulo: 'Pipeline' },
        { chave: 'responsavel_nome', rotulo: 'Responsável' },
        { chave: 'loja_nome', rotulo: 'Loja' },
      ]
    },
    variaveisCampos() {
      const vistos = {}
      this.variaveisFixas.forEach(function (item) {
        vistos[item.chave] = true
      })
      const lista = []
      ;(this.camposCustomizados || []).forEach((campo) => {
        const chave = 'campos_customizados_' + String(campo.value || '').toLowerCase().replace(/ /g, '_')
        if (!chave || chave === 'campos_customizados_' || vistos[chave]) {
          return
        }
        vistos[chave] = true
        lista.push({ chave: chave, rotulo: campo.value })
      })

      return lista
    },
    campoSelecionado() {
      if (!this.no || !this.no.data.campo_id) {
        return null
      }
      return this.camposCustomizados.find((campo) => String(campo.id) === String(this.no.data.campo_id)) || null
    },
    tipoCampoSelecionado() {
      return this.campoSelecionado ? Number(this.campoSelecionado.tipo) : 0
    },
    mostraFaseDe() {
      const regra = this.no && this.no.data.fase_regra
      return regra === 'sair' || regra === 'de_para'
    },
    mostraFasePara() {
      const regra = this.no && this.no.data.fase_regra
      return regra === 'entrar' || regra === 'de_para'
    },
    opcoesCampoSelecionado() {
      return (this.campoSelecionado && this.campoSelecionado.opcoes) || []
    },
    conexaoWhatsappSelecionada() {
      if (!this.no || !this.no.data.config_eloca_hyperflow_id) {
        return null
      }
      return (this.conexoes || []).find((conexao) => String(conexao.id) === String(this.no.data.config_eloca_hyperflow_id)) || null
    },
    whatsappOficial() {
      const tipo = this.conexaoWhatsappSelecionada ? Number(this.conexaoWhatsappSelecionada.tipo_integracao) : 0
      return tipo === 1 || tipo === 6
    },
    whatsappNaoOficial() {
      return this.conexaoWhatsappSelecionada ? Number(this.conexaoWhatsappSelecionada.tipo_integracao) === 3 : false
    },
    mostraTemplateWhatsapp() {
      if (!this.no || this.no.data.canal !== 'whatsapp') {
        return false
      }
      return !this.conexaoWhatsappSelecionada || this.whatsappOficial
    },
    mostraTextoWhatsappLivre() {
      return this.no && this.no.data.canal === 'whatsapp' && this.whatsappNaoOficial
    },
    templatesDaConexao() {
      const conexaoId = this.no && this.no.data.config_eloca_hyperflow_id
      if (!conexaoId) {
        return this.templates
      }
      return (this.templates || []).filter((template) => String(template.config_eloca_hyperflow_id) === String(conexaoId))
    },
    aguardarRespostaValor() {
      if (!this.no) {
        return '0'
      }
      const valor = this.no.data.aguardar_resposta
      return valor === '1' || valor === 1 || valor === true ? '1' : '0'
    },
    aguardaResposta() {
      return this.aguardarRespostaValor === '1'
    },
    rotuloDestinatarioMensagem() {
      if (!this.no || this.no.data.canal === 'whatsapp') {
        return 'Cliente, via responsável'
      }
      if (this.no.data.destinatario_email_tipo === 'outro') {
        return this.no.data.destinatario_email || 'Outro e-mail'
      }
      return 'E-mail do cliente da oportunidade'
    },
    rotuloCanalMensagem() {
      if (!this.no || this.no.data.canal !== 'whatsapp') {
        return 'SMTP da loja'
      }
      if (this.whatsappNaoOficial) {
        return 'WhatsApp não oficial'
      }
      if (this.whatsappOficial) {
        return 'Template WhatsApp oficial'
      }
      return 'Template Hyperflow'
    },
    rotuloOportunidadeAlvo() {
      if (!this.no) {
        return 'A que disparou o fluxo'
      }
      const alvo = this.no.data.alvo || 'atual'
      if (alvo === 'criada') {
        return 'Última criada neste fluxo'
      }
      const item = this.oportunidadesDoFluxo.find(function (opcao) {
        return String(opcao.id) === String(alvo)
      })
      return item ? item.rotulo : 'A que disparou o fluxo'
    },
  },
  methods: {
    sincronizarSelects() {
      this.$el.querySelectorAll('select').forEach(function (select) {
        if (!Object.prototype.hasOwnProperty.call(select, '_value')) {
          return
        }
        const valor = select._value === null || select._value === undefined ? '' : String(select._value)
        if (select.value !== valor) {
          select.value = valor
        }
      })
    },
    horarioDoDia(dia) {
      const semana = this.no && this.no.data && this.no.data.semana
      if (Array.isArray(semana)) {
        const achado = semana.find(function (item) {
          return Number(item.dia) === Number(dia)
        })
        if (achado) {
          return {
            ativo: !!achado.ativo,
            inicio: achado.inicio || '08:00',
            fim: achado.fim || '18:00',
          }
        }
      }
      const dias = (this.no && this.no.data && this.no.data.dias) || []
      return {
        ativo: dias.map(String).indexOf(String(dia)) !== -1,
        inicio: (this.no && this.no.data && this.no.data.inicio) || '08:00',
        fim: (this.no && this.no.data && this.no.data.fim) || '18:00',
      }
    },
    alterarHorarioDia(dia, campo, valor) {
      const semana = this.diasSemana.map((item) => {
        const atual = this.horarioDoDia(item.id)
        if (Number(item.id) !== Number(dia)) {
          return { dia: item.id, ativo: atual.ativo, inicio: atual.inicio, fim: atual.fim }
        }
        return {
          dia: item.id,
          ativo: campo === 'ativo' ? !!valor : atual.ativo,
          inicio: campo === 'inicio' ? (valor || null) : atual.inicio,
          fim: campo === 'fim' ? (valor || null) : atual.fim,
        }
      })
      this.gravarHorario({ semana: semana })
    },
    alterarExcecao(indice, campo, valor) {
      const lista = this.excecoesHorario.slice()
      const item = Object.assign({}, lista[indice] || {})
      item[campo] = campo === 'fechado' ? !!valor : (valor || null)
      lista[indice] = item
      this.gravarHorario({ excecoes: lista })
    },
    adicionarExcecao() {
      if (!this.podeAdicionarExcecao) {
        return
      }
      const lista = this.excecoesHorario.slice()
      lista.push({ data: null, fechado: false, inicio: '08:00', fim: '12:00' })
      this.gravarHorario({ excecoes: lista })
    },
    removerExcecao(indice) {
      const lista = this.excecoesHorario.slice()
      lista.splice(indice, 1)
      this.gravarHorario({ excecoes: lista })
    },
    gravarHorario(parcial) {
      const data = Object.assign({}, this.no.data, parcial)
      if (parcial.semana) {
        delete data.dias
        delete data.inicio
        delete data.fim
      }
      this.$emit('atualizar-no', this.no.id, data)
    },
    alterar(campo, valor) {
      const data = Object.assign({}, this.no.data)
      data[campo] = valor === '' ? null : valor
      this.$emit('atualizar-no', this.no.id, data)
    },
    alterarConexaoWhatsapp(valor) {
      const data = Object.assign({}, this.no.data)
      data.config_eloca_hyperflow_id = valor === '' ? null : valor
      data.template_id = null
      this.$emit('atualizar-no', this.no.id, data)
    },
    inserirVariavel(campo, chave) {
      if (!this.no || !chave) {
        return
      }
      const atual = this.no.data[campo] == null ? '' : String(this.no.data[campo])
      const token = '{{' + chave + '}}'
      const extra = atual !== '' && !/\s$/.test(atual) ? ' ' : ''
      this.alterar(campo, atual + extra + token)
    },
    operadoresPorTipo(tipo) {
      if (tipo === 3) {
        return [
          { id: 'preenchido', value: 'Está preenchido' },
          { id: '=', value: 'É igual a' },
          { id: '>', value: 'Maior que' },
          { id: '<', value: 'Menor que' },
          { id: '>=', value: 'Maior ou igual' },
          { id: '<=', value: 'Menor ou igual' },
        ]
      }
      if (tipo === 4) {
        return [
          { id: 'preenchido', value: 'Está preenchido' },
          { id: '=', value: 'É igual a' },
          { id: '>', value: 'Depois de' },
          { id: '<', value: 'Antes de' },
          { id: '>=', value: 'A partir de' },
          { id: '<=', value: 'Até' },
        ]
      }
      if (tipo === 1) {
        return [
          { id: 'preenchido', value: 'Está preenchido' },
          { id: '=', value: 'É igual a' },
          { id: 'contem', value: 'Contém' },
        ]
      }
      return [
        { id: 'preenchido', value: 'Está preenchido' },
        { id: '=', value: 'É igual a' },
      ]
    },
    alterarPipelineGatilho(valor) {
      const data = Object.assign({}, this.no.data)
      data.pipeline_id = valor === '' ? null : Number(valor)
      data.fase_de = null
      data.fase_para = null
      data.fase_de_ids = []
      data.fase_para_ids = []
      this.$emit('atualizar-no', this.no.id, data)
    },
    alterarFaseRegra(valor) {
      const data = Object.assign({}, this.no.data)
      data.fase_regra = valor || 'qualquer'
      if (data.fase_regra === 'qualquer') {
        data.fase_de = null
        data.fase_para = null
        data.fase_de_ids = []
        data.fase_para_ids = []
      }
      if (data.fase_regra === 'entrar') {
        data.fase_de = null
        data.fase_de_ids = []
      }
      if (data.fase_regra === 'sair') {
        data.fase_para = null
        data.fase_para_ids = []
      }
      this.$emit('atualizar-no', this.no.id, data)
    },
    alterarIdGatilho(lista, unico, indice, valor) {
      const ids = this.listaIdsGatilho(lista, unico)
      ids[indice] = valor === '' ? null : valor
      this.gravarIdsGatilho(lista, unico, ids)
    },
    adicionarIdGatilho(lista, unico, vazio) {
      const ids = this.listaIdsGatilho(lista, unico)
      if (ids.length >= LIMITE_REGRAS_CONDICAO) {
        return
      }
      ids.push(vazio)
      this.gravarIdsGatilho(lista, unico, ids)
    },
    removerIdGatilho(lista, unico, indice) {
      const ids = this.listaIdsGatilho(lista, unico)
      if (lista === 'fase_de_ids' || lista === 'fase_para_ids') {
        if (ids.length < 2) {
          return
        }
      }
      ids.splice(indice, 1)
      this.gravarIdsGatilho(lista, unico, ids)
    },
    listaIdsGatilho(lista, unico) {
      if (lista === 'fase_de_ids') {
        return this.faseDeIds.slice()
      }
      if (lista === 'fase_para_ids') {
        return this.faseParaIds.slice()
      }
      if (lista === 'status_ids') {
        return this.statusIds.slice()
      }
      if (lista === 'campo_ids') {
        return this.campoIds.slice()
      }

      return idsDoGatilho(this.no.data, lista, unico).slice()
    },
    gravarIdsGatilho(lista, unico, ids) {
      const data = Object.assign({}, this.no.data)
      data[lista] = ids.slice()
      const primeiro = ids.find(function (id) {
        return id !== null && id !== undefined && id !== ''
      })
      data[unico] = primeiro === undefined ? null : primeiro
      this.$emit('atualizar-no', this.no.id, data)
    },
    alterarCampoAtualizar(valor) {
      const data = Object.assign({}, this.no.data)
      data.campo_id = valor === '' ? null : valor
      data.campo_valor = null
      this.$emit('atualizar-no', this.no.id, data)
    },
    alterarLogica(valor) {
      this.gravarRegras(this.regrasCondicao.slice(), valor === 'e' ? 'e' : 'ou')
    },
    alterarLogicaGatilho(valor) {
      const data = Object.assign({}, this.no.data)
      data.logica = valor === 'e' ? 'e' : 'ou'
      this.$emit('atualizar-no', this.no.id, data)
    },
    alterarRegra(indice, campo, valor) {
      const regras = this.regrasCondicao.slice()
      const regra = Object.assign({}, regras[indice] || {})
      regra[campo] = valor === '' ? null : valor
      regras[indice] = regra
      this.gravarRegras(regras, this.logicaCondicao)
    },
    alterarValorRegra(indice, texto) {
      this.alterarRegra(indice, 'valor', parsearValorBr(mascararValorDigitado(texto)))
    },
    alterarCampoRegra(indice, valor) {
      const regras = this.regrasCondicao.slice()
      const regra = Object.assign({}, regras[indice] || {})
      regra.campo_id = valor === '' ? null : valor
      regra.valor = null
      const campo = this.camposCustomizados.find(function (item) {
        return String(item.id) === String(valor)
      })
      const operadores = this.operadoresPorTipo(campo ? Number(campo.tipo) : 0).map(function (item) {
        return item.id
      })
      if (operadores.indexOf(regra.op) === -1) {
        regra.op = 'preenchido'
      }
      regras[indice] = regra
      this.gravarRegras(regras, this.logicaCondicao)
    },
    adicionarRegra() {
      if (!this.podeAdicionarRegra) {
        return
      }
      const regras = this.regrasCondicao.slice()
      regras.push(this.regraVazia())
      this.gravarRegras(regras, this.logicaCondicao)
    },
    removerRegra(indice) {
      const regras = this.regrasCondicao.slice()
      if (regras.length < 2) {
        return
      }
      regras.splice(indice, 1)
      this.gravarRegras(regras, this.logicaCondicao)
    },
    gravarRegras(regras, logica) {
      const data = Object.assign({}, this.no.data)
      const lista = regras.slice()
      const primeira = lista[0] || {}
      data.regras = lista
      data.logica = this.no.data.tipo === 'pipeline_id' || this.no.data.tipo === 'origem' ? 'ou' : logica
      if (Object.prototype.hasOwnProperty.call(primeira, 'op')) {
        data.op = primeira.op
      }
      if (Object.prototype.hasOwnProperty.call(primeira, 'valor')) {
        data.valor = primeira.valor
      }
      if (Object.prototype.hasOwnProperty.call(primeira, 'campo_id')) {
        data.campo_id = primeira.campo_id
      }
      this.$emit('atualizar-no', this.no.id, data)
    },
    regraVazia() {
      const tipo = this.no && this.no.data && this.no.data.tipo
      if (tipo === 'origem') {
        return { valor: 'whatsapp' }
      }
      if (tipo === 'valor') {
        return { op: '>=', valor: null }
      }
      if (tipo === 'campo') {
        return { campo_id: null, op: 'preenchido', valor: null }
      }
      if (tipo === 'resposta') {
        return { op: 'respondeu', valor: null }
      }
      return { valor: null }
    },
    valorFormatadoDaRegra(regra) {
      if (!regra || regra.valor === null || regra.valor === undefined || regra.valor === '') {
        return ''
      }
      return formatarValorBr(regra.valor)
    },
    campoDaRegra(regra) {
      if (!regra || !regra.campo_id) {
        return null
      }
      return this.camposCustomizados.find((campo) => String(campo.id) === String(regra.campo_id)) || null
    },
    tipoDaRegra(regra) {
      const campo = this.campoDaRegra(regra)
      return campo ? Number(campo.tipo) : 0
    },
    operadoresDaRegra(regra) {
      return this.operadoresPorTipo(this.tipoDaRegra(regra))
    },
    mostraValorDaRegra(regra) {
      return regra && regra.op && regra.op !== 'preenchido' && regra.op !== 'respondeu'
    },
    opcoesDaRegra(regra) {
      const campo = this.campoDaRegra(regra)
      return (campo && campo.opcoes) || []
    },
    alterarPipeline(valor) {
      const data = Object.assign({}, this.no.data)
      data.pipeline_id = valor === '' ? null : valor
      data.fase_id = null
      if (data.user_id && data.user_id !== 'atual' && data.user_id !== '0' && data.user_id !== 0) {
        const usuarios = this.usuariosPorPipeline[valor] || this.usuariosPorPipeline[String(valor)] || []
        const aindaNaPipeline = usuarios.some(function (usuario) {
          return String(usuario.id) === String(data.user_id)
        })
        if (!aindaNaPipeline) {
          data.user_id = 'atual'
        }
      }
      this.$emit('atualizar-no', this.no.id, data)
    },
  },
}
</script>
